// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world

$w.onReady(function () {
	// 

	// To select an element by ID use: $w("#elementID")

	// Click "Preview" to run your code
});